import { AutomatedBreaksApiFields } from '@sdk/authentication/types/apiTypes';

import { useAutomatedBreaksSettings } from '@web/settings/components/schedule/Breaks/breaks.hooks';
import { AutomatedBreaksSettingsFormFields } from '@web/settings/components/schedule/Breaks/breaks.types';

export const useAutomatedBreakContentFields = (fields: AutomatedBreaksSettingsFormFields) => {
  const { updateAutomatedBreaksSettings } = useAutomatedBreaksSettings();

  const updateAttestation = (attestation: boolean) => {
    fields.isAttestation.onChange(attestation);
    updateAutomatedBreaksSettings({
      [AutomatedBreaksApiFields.automatedBreaksIsAttestation]: attestation,
    });
  };

  const updateMealBreakEnabled = (mealBreakEnabled: boolean) => {
    fields.meal.isEnabled.onChange(mealBreakEnabled);
    updateAutomatedBreaksSettings({
      [AutomatedBreaksApiFields.automatedBreaksMealIsEnabled]: mealBreakEnabled,
    });
  };

  const updateRestBreakEnabled = (restBreakEnabled: boolean) => {
    fields.rest.isEnabled.onChange(restBreakEnabled);
    updateAutomatedBreaksSettings({
      [AutomatedBreaksApiFields.automatedBreaksRestIsEnabled]: restBreakEnabled,
    });
  };

  return {
    updateAttestation,
    updateMealBreakEnabled,
    updateRestBreakEnabled,
  };
};
